export class ReferenceDataItem {
    Id: string;
    Name: string;
}

export default ReferenceDataItem;